import {Api} from '../../Api.js'

const RESOURCE = 'user'

export default {
    resource: RESOURCE,
    all(query) {
        return Api().get(this.resource + '/all'  + (query ? query : '') )
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
}


// WEBPACK FOOTER //
// ./src/modules/scope/UserService.js